import React from 'react'
import Select from 'react-select'
import { ISearchSelectProps } from '../../utility/types'

function SearchSelect(props: ISearchSelectProps) {
  let {
    label,
    valueForDisplay,
    variant,
    style = { wrapper: {} },
    className = '',
    noBorder,
    separator = false,
    t
  } = props
  let boxShadow: any = null
  if (noBorder) {
    boxShadow = {
      border: '0px solid transparent',
      '&:hover': {
        borderColor: 'transparent'
      },
      '&:focusWithin': {
        boxShadow: '0 0 0 0px rgba(0,0,0,0)'
      }
    }
  }
  const styleVariant =
    variant && variant === 'fareyeV2'
      ? {
          control: (styles: any) => ({
            ...styles,
            ...{ minHeight: '20px' }
          }),
          placeholder: (styles: any) => ({
            ...styles,
            ...{ padding: '0 4px' }
          }),
          indicatorContainer: (styles: any) => ({
            ...styles,
            ...{ padding: '0 8px' }
          })
        }
      : {}

  let { className: _className, value, ...rest } = props
  const OtherProps = { ...props }
  delete OtherProps.className

  if (
    value &&
    !Array.isArray(value) &&
    !(value as any)[valueForDisplay || 'value']
  ) {
    OtherProps.value = null
  }
  const fmtOptions: any = {}
  if (!props.getOptionLabel) {
    fmtOptions.formatOptionLabel = (data: any, meta: any) => {
      return t && data?.label ? t(data.label) : data?.label
    }
  }
  return (
    <div
      className={`feui-search-select ${className}`}
      style={{ width: '100%', ...style.wrapper }}
    >
      {label && <label style={style.label}>{label}</label>}
      <Select
        classNamePrefix="fe-ui"
        styles={{
          ...{
            container: base => ({
              ...base,
              border: 0,
              width: '100%',
              backgroundColor: 'transparent',
              ...style.container
            }),
            control: styles => ({
              ...styles,
              width: '100%',
              display: 'flex',
              position: 'relative',
              cursor: 'pointer',
              gridTemplateColumns: '1fr 1fr',
              transition: 'all .3s cubic-bezier(.645, .045, .355, 1)',
              boxSizing: 'border-box',
              background: 'transparent',
              borderTopWidth: '1.02px',
              borderRadius: '4px',
              outline: 'none',
              userSelect: 'none',
              '&:focusWithin': {
                borderColor: 'transparent',
                borderWidth: '1px !important',
                outline: 0
              },
              ...boxShadow,
              ...style.control
            }),
            menu: styles => ({
              ...styles,
              width: 'auto',
              minWidth: '100%',
              zIndex: 410, // 400 leaflet map
              ...style.menu
            }),
            indicatorSeparator: () => ({
              ...(separator ? {} : { display: 'none' }),
              ...style.indicatorSeparator
            }),
            option: (provided, state) => {
              const optionCss =
                typeof style.option === 'function'
                  ? style.option(state)
                  : style.option
              return {
                ...provided,
                padding: '5px 10px',
                maxHeight: '250px',
                outline: 'none',
                ...optionCss
              }
            },
            singleValue: (styles, { data }) => ({
              ...styles,
              color: 'rgba(100,100,100,1)',
              ...style.singleValue
            }),
            placeholder: styles => ({
              ...styles,
              display: 'flex',
              padding: '0 4px',
              color: 'rgba(151,151,151,1)',
              ...style.placeholder
            }),
            input: styles => ({
              ...styles,
              color: 'rgba(151,151,151,1)',
              ...style.input
            }),
            valueContainer: (styles, state) => ({
              ...styles,
              background: 'transparent',
              // height: '35px',
              overflow: 'auto',
              ...style.valueContainer
            }),
            dropdownIndicator: (styles, state) => ({
              ...styles,
              color: 'rgba(207,207,207,1)',
              transition: '0.3s',
              transform: 'rotate(180deg)',
              display: 'none',
              ...style.dropdownIndicator
            })
          },
          ...styleVariant
        }}
        // value={value}
        {...fmtOptions}
        {...OtherProps}
      />
    </div>
  )
}

export default SearchSelect
